

































import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Post} from '@/models/post';
import PostInfo from '@/components/PostInfo.vue';
import PostCategory from '@/components/PostCategory.vue';
const blog = namespace('blog');
@Component({
  components: {PostCategory, PostInfo},
})
export default class RelatedPosts extends Vue {
  @blog.State
  private relatedPosts!: Post[];
}
